<div id="home-container">
  <div class="" id="image-container"></div>

  <div id="dropdown-container">
    <h3>Choose a campaign:</h3>
    <!-- START: Dropdown menu with tables -->
    <p-autocomplete
      [dropdown]="true"
      id="id"
      name="name"
      [(ngModel)]="selectedCampaign"
      [suggestions]="suggestions!"
      (completeMethod)="searchCampaign($event)"
      required="true"
      optionLabel="name"
      delay="0"
      placeholder="Enter campaign name"
      scrollHeight="400px"
      emptyMessage="No campaign found!"
      inputStyleClass="search-campaign-autocomplete"
      [style]="{ zIndex: '3' }"
      (onSelect)="routeToCampaign()"
      ><ng-template let-campaign pTemplate="item">
        <div [style.white-space]="'pre-wrap'">
          {{ campaign.hint }}
        </div>
      </ng-template>
    </p-autocomplete>
    <!-- END: Dropdown menu with tables -->
  </div>
</div>
